import baseService from './baseService'

export const userService = {
  login,
  getDropdownData,
  register,
  init,
  resetPassword
}

function login (loginDto) {
  return baseService.postRequest('users/authenticate-code', loginDto)
}

function getDropdownData () {
  return baseService.getRequest('public/kontiky/getRegistrationDropdownData')
}

function register (registrationDto) {
  return baseService.postRequest('public/kontiky/auth/register', registrationDto)
}

function init (client) {
  return baseService.postRequest(`public/kontiky/init`, { url: client })
}

function resetPassword (request) {
  return baseService.postRequest('public/kontiky/auth/reset', request)
}
